
import messages from  "@/store/modules/Setting/authen/messages/index";

const module = {
    namespaced: true,
    modules: {
        messages
    },
    state: {

    },



    mutations: {

    },

    actions: {

    },

    getters: {


    },
};
export default module;
